class Textfield extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="textfield">
          Textfield
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#elements-mixin-textfield" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Different text fields</h4>
              <p>
                NOTE: The textfield mixin requires your input field to be wrapped in a display
                block container to properly handle icon layouts
              </p>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="textfield-demo">
  <div class="regular">
    <input type="text" placeholder="Regular text field" />
  </div>
  <div class="regular-light">
    <input type="text" placeholder="Regular text field - light theme" />
  </div>
  <div class="regular-disabled">
    <input type="text" placeholder="Regular text field - disabled" disabled />
  </div>
  <div class="regular-light-disabled">
    <input type="text" placeholder="Regular text field - light theme disabled" disabled />
  </div>
  <div class="icon">
    <input type="text" placeholder="Text field with icon" />
  </div>
  <div class="icon-light">
    <input type="text" placeholder="Text field with icon - light theme" />
  </div>
  <div class="icon-disabled">
    <input type="text" placeholder="Disabled text field with icon" disabled />
  </div>
  <div class="icon-light-disabled">
    <input type="text" placeholder="Disabled text field with icon - light theme" disabled />
  </div>
  <div class="icon-pre">
    <input type="text" placeholder="Text field with pre icon" />
  </div>
  <div class="icon-pre-light">
    <input type="text" placeholder="Text field with pre icon - light theme" />
  </div>
  <div class="icon-pre-disabled">
    <input type="text" placeholder="Disabled text field with pre icon" disabled />
  </div>
  <div class="icon-pre-light-disabled">
    <input type="text" placeholder="Disabled text field with pre icon - light theme" disabled />
  </div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.textfield-demo {
  div {
    margin-bottom: 20px;
  }

  .regular {
    @include textfield();
  }

  .regular-light {
    @include textfield($theme: light);
  }

  .regular-disabled {
    @include textfield($disabled: true);
  }

  .regular-light-disabled {
    @include textfield($theme: light, $disabled: true);
  }

  .icon {
    @include textfield($icon: lock);
  }

  .icon-light {
    @include textfield($theme: light, $icon: lock);
  }

  .icon-disabled {
    @include textfield($icon: lock, $disabled: true);
  }

  .icon-light-disabled {
    @include textfield($theme: light, $icon: lock, $disabled: true);
  }

  .icon-pre {
    @include textfield($icon: usd, $icon-position: before);
  }

  .icon-pre-light {
    @include textfield($theme: light, $icon: usd, $icon-position: before);
  }

  .icon-pre-disabled {
    @include textfield($icon: usd, $icon-position: before, $disabled: true);
  }

  .icon-pre-light-disabled {
    @include textfield($theme: light, $icon: usd, $icon-position: before, $disabled: true);
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="textfield-demo">
                    <div className="regular">
                      <input type="text" placeholder="Regular text field" />
                    </div>
                    <div className="regular-light">
                      <input type="text" placeholder="Regular text field - light theme" />
                    </div>
                    <div className="regular-disabled">
                      <input type="text" placeholder="Regular text field - disabled" disabled={true} />
                    </div>
                    <div className="regular-light-disabled">
                      <input type="text" placeholder="Regular text field - light theme disabled" disabled={true} />
                    </div>
                    <div className="icon">
                      <input type="text" placeholder="Text field with icon" />
                    </div>
                    <div className="icon-light">
                      <input type="text" placeholder="Text field with icon - light theme" />
                    </div>
                    <div className="icon-disabled">
                      <input type="text" placeholder="Disabled text field with icon" disabled={true} />
                    </div>
                    <div className="icon-light-disabled">
                      <input type="text" placeholder="Disabled text field with icon - light theme" disabled={true} />
                    </div>
                    <div className="icon-pre">
                      <input type="text" placeholder="Text field with pre icon" />
                    </div>
                    <div className="icon-pre-light">
                      <input type="text" placeholder="Text field with pre icon - light theme" />
                    </div>
                    <div className="icon-pre-disabled">
                      <input type="text" placeholder="Disabled text field with pre icon" disabled={true} />
                    </div>
                    <div className="icon-pre-light-disabled">
                      <input type="text" placeholder="Disabled text field with pre icon - light theme" disabled={true} />
                    </div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
